document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('defyne-size-guide-modal');
  if (!modal) return;
  var overlay = document.getElementById('defyne-modal-overlay');
  var closeBtn = document.getElementById('defyne-modal-close');

  function openModal(e) {
    if (e) e.preventDefault();
    modal.hidden = false;
  }

  function closeModal() {
    modal.hidden = true;
  }

  document.querySelectorAll('.defyne-size-guide-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', openModal);
  });

  overlay.addEventListener('click', closeModal);
  closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
});
